import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing069({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/069/25011001.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/069/25011002.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/069/25011003.jpg`} // 스텝 변경되는 이미지
      numberColor="#006864"
      qOptionColor="red"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/nextStepButton2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/applyButton2.png`}
      companyName="미라클플란트치과의원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기' 버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/miracle.jpg`}
    />
  );
}

export default Randing069;
